/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ShallowCompanyList
 */
export interface ShallowCompanyList {
  /**
   *
   * @type {string}
   * @memberof ShallowCompanyList
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof ShallowCompanyList
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ShallowCompanyList
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof ShallowCompanyList
   */
  updatedAt: string
}

export function ShallowCompanyListFromJSON(json: any): ShallowCompanyList {
  return ShallowCompanyListFromJSONTyped(json, false)
}

export function ShallowCompanyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShallowCompanyList {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    createdAt: json['created_at'],
    updatedAt: json['updated_at']
  }
}

export function ShallowCompanyListToJSON(value?: ShallowCompanyList | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    created_at: value.createdAt,
    updated_at: value.updatedAt
  }
}
